import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Shrimp from '../../../svg/Shrimp.js';
import TheCulinistas from '../../../svg/TheCulinistas.js';
import { navy } from '../../../const.js';

class Begin extends Component {
  state = {};
  render() {
    return (
      <InfoBox
        headline="Welcome!"
        subline="We are currently offering our weekly meal prep service
          in New York, the Hamptons, Los Angeles, Connecticut &amp; the DC Metro
          areas. We need a bit of information to get you set up with one of 
          our in home personalized chefs."
        icon={<Shrimp />}
      >
        <TheCulinistas color={navy} className="onboarding-new__logo" />
      </InfoBox>
    );
  }
}

export default Begin;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Begin.js